/**
 * Notification.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import event from 'utils/event';
import { CLOUDFRONT_URL } from 'utils';
import { FaArrowRight, FaRegTimesCircle } from 'react-icons/fa';
import defaultProfileImage from '../../assets/defaultProfileImage.png';

import {
  NotificationContainer,
  NotificationLink,
  NotificationInfo,
  NotificationImage,
  NotificationText,
  NotificationDate,
  ArrowsXs,
} from './Notification.styles';


/**
 * A Notification to show on the Notification screen and notifications dropdown
 */
export default class Notification extends Component {
  constructor(props) {
    super(props);
    const { notification, user } = props;
    let image = notification.image ? notification.image : `${CLOUDFRONT_URL}/quizhive_q.png`;
    let goToLink = notification.goToLink ? notification.goToLink : `/`;
    let name = notification.text;
    const regularText = notification.regularText ? notification.regularText : null;
    if (notification.name === `AB`) {
      image = notification.badge.image_url;
      goToLink = `/badges/${notification.badge.slug}`;
      name = notification.text.replace(`%s`, notification.badge.name);
    } else if (notification.name === `NF`) {
      image = notification.creator.profile ? notification.creator.profile.photo : null;
      goToLink = `/profile/${notification.creator.id}`;
      name = notification.text.replace(`%s`, notification.creator.name);
    } else if (notification.name === `NS`) {
      goToLink = `/profile/${user.id}/badges`;
    } else if (notification.name === `NQ`) {
      goToLink = `/`;
    } else if (notification.name === `VQ`) {
      goToLink = `/profile/${user.id}/questions`;
    }


    this.state = {
      image,
      goToLink,
      name,
      regularText,
    };
  }

  onClick = () => {
    const { clickNotification, notification } = this.props;

    clickNotification(notification);
    event(`click-notification`, [`click`, `click-notification`, `${notification.id}`]);
  }

  render() {
    const { notification, isStatic, renderedInMenu } = this.props;
    const { image, goToLink, name, regularText } = this.state;
    return (
      <NotificationContainer renderedInMenu={renderedInMenu}>
        <NotificationLink to={ goToLink } onClick={ !isStatic ? this.onClick : null }>
          <NotificationInfo>
            <NotificationImage
              src={ image || defaultProfileImage }
              alt={ `Notification image for ${name}` }
              renderedInMenu={renderedInMenu}
            />
            <NotificationText newNotif={ !(notification.clicked_ts || isStatic) }>
              {name}
              {!isStatic
                ? <NotificationDate renderedInMenu={ renderedInMenu }>
                  { distanceInWordsToNow(new Date(notification.created_ts)) } ago
                </NotificationDate>
                : <NotificationDate renderedInMenu={ renderedInMenu }>
                  {regularText}
                </NotificationDate>}
            </NotificationText>
          </NotificationInfo>
          <ArrowsXs renderedInMenu={ renderedInMenu } isStatic={ isStatic }>
            <FaArrowRight />
          </ArrowsXs>
        </NotificationLink>
        {renderedInMenu && !isStatic
          ? <ArrowsXs renderedInMenu isCircle>
            <FaRegTimesCircle onClick={ this.onClick } />
          </ArrowsXs>
          : null}
      </NotificationContainer>
    );
  }
}

if (process.env.NODE_ENV !== `production`) {
  const PropTypes = require(`prop-types`); // eslint-disable-line
  Notification.propTypes = {
    notification: PropTypes.object.isRequired,
    clickNotification: PropTypes.func,
    isStatic: PropTypes.bool,
    user: PropTypes.object,
    renderedInMenu: PropTypes.bool,
  };
}
